import { FC, useCallback } from "react";
import { SelectChangeEvent } from "@mui/material";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { normalizedCostWidgetSetupVisualizationChartTypeSelector } from "@/store/dashboards/selectors/setups/normalized-cost-widget/visualization/normalizedCostWidgetSetupVisualizationChartTypeSelector";
import { WidgetViewType } from "@/store/dashboards/utils/types/types";
import { ChartType } from "@/services/cloudchipr.api";
import { WidgetViewTypeSelect } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/common/WidgetViewTypeSelect";
import { normalizedCostWidgetVisualizationChangeThunk } from "@/store/dashboards/thunks/widgets/normalized-cost-widget/setup-change/normalizedCostWidgetVisualizationChangeThunk";
import { getNormalizedCostWidgetSetupDataThunk } from "@/store/dashboards/thunks/widgets/normalized-cost-widget/getNormalizedCostWidgetSetupDataThunk";

export const NormalizedCostWidgetChartTypeSelect: FC = () => {
  const dispatch = useAppDispatch();
  const chartType = useAppSelector(
    normalizedCostWidgetSetupVisualizationChartTypeSelector,
  );

  const handleChange = useCallback(
    (event: SelectChangeEvent<WidgetViewType>) => {
      dispatch(
        normalizedCostWidgetVisualizationChangeThunk({
          chart_type: event.target.value as ChartType,
        }),
      );
      dispatch(getNormalizedCostWidgetSetupDataThunk());
    },
    [dispatch],
  );

  return (
    <WidgetViewTypeSelect
      viewType={chartType}
      options={options}
      onChange={handleChange}
    />
  );
};

const options: WidgetViewType[] = ["line", "column", "table"];
